import { render, staticRenderFns } from "./connectionfail.vue?vue&type=template&id=72928b84&lang=pug"
import script from "./connectionfail.vue?vue&type=script&lang=js"
export * from "./connectionfail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports